import { api } from '@/api';
import type { Paths as AgentPaths } from '@/types/schemas/agent-schema';
import type { Paths as ProxyPaths } from '@/types/schemas/proxy-schema';

export const PROFILE_BOOKINGS_PAGE_SIZE = 10;

export const fetchProfileBookings = async (
  request: ProxyPaths.BookingsSearchSearchByTravelAccount.RequestBody,
  offset?: number
) => {
  const data = (
    await api.proxyApi.BookingsSearch_SearchByTravelAccount(
      {
        limit: PROFILE_BOOKINGS_PAGE_SIZE,
        offset: offset ?? 0,
        SortBy: 'DepartureAndActivationTime(Desc)',
      },
      request
    )
  ).data as AgentPaths.BookingsSearchSearchBookingsCustom.Responses.$200;

  return {
    data: data.bookingsSearchResults ?? [],
    totalCount: data.totalCount,
  };
};
